// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._3Group-module__container___jYPQW {
    position: relative;
    display: inline-block;
    height: 350px;
    width: auto;
    aspect-ratio: 244/350;

    transform: perspective(2000px);
    transition: all 0.3s ease;
    /* Add depth to the whole panel */
    box-shadow: 
        -20px 20px 30px rgba(0, 0, 0, 0.2),
        -5px 5px 15px rgba(0, 0, 0, 0.1),
        inset 2px -2px 5px rgba(255, 255, 255, 0.2);
}

._3Group-module__backgroundImage____CrD9 {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: contain;

    background: linear-gradient(
        105deg,
        rgba(255, 255, 255, 0.2) 0%,
        rgba(255, 255, 255, 0) 40%
    );
}

._3Group-module__overlayImage___NeXFD,
._3Group-module__overlayVideo___HkHr1 {
    position: absolute;
    top: 5%;
    left: 7%;
    width: 86.5%;
    height: 91%;
    object-fit: cover;
    clip-path: inset(2px 0 0 0); /*the images has a white line at the top*/
}
`, "",{"version":3,"sources":["webpack://./app/components/ProofOfDeliveryLayout/Panels/3Group/3Group.module.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,aAAa;IACb,WAAW;IACX,qBAAqB;;IAErB,8BAA8B;IAC9B,yBAAyB;IACzB,iCAAiC;IACjC;;;mDAG+C;AACnD;;AAEA;IACI,cAAc;IACd,WAAW;IACX,YAAY;IACZ,mBAAmB;;IAEnB;;;;KAIC;AACL;;AAEA;;IAEI,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,YAAY;IACZ,WAAW;IACX,iBAAiB;IACjB,2BAA2B,EAAE,yCAAyC;AAC1E","sourcesContent":[".container {\n    position: relative;\n    display: inline-block;\n    height: 350px;\n    width: auto;\n    aspect-ratio: 244/350;\n\n    transform: perspective(2000px);\n    transition: all 0.3s ease;\n    /* Add depth to the whole panel */\n    box-shadow: \n        -20px 20px 30px rgba(0, 0, 0, 0.2),\n        -5px 5px 15px rgba(0, 0, 0, 0.1),\n        inset 2px -2px 5px rgba(255, 255, 255, 0.2);\n}\n\n.backgroundImage {\n    display: block;\n    width: 100%;\n    height: 100%;\n    object-fit: contain;\n\n    background: linear-gradient(\n        105deg,\n        rgba(255, 255, 255, 0.2) 0%,\n        rgba(255, 255, 255, 0) 40%\n    );\n}\n\n.overlayImage,\n.overlayVideo {\n    position: absolute;\n    top: 5%;\n    left: 7%;\n    width: 86.5%;\n    height: 91%;\n    object-fit: cover;\n    clip-path: inset(2px 0 0 0); /*the images has a white line at the top*/\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `_3Group-module__container___jYPQW`,
	"backgroundImage": `_3Group-module__backgroundImage____CrD9`,
	"overlayImage": `_3Group-module__overlayImage___NeXFD`,
	"overlayVideo": `_3Group-module__overlayVideo___HkHr1`
};
export default ___CSS_LOADER_EXPORT___;
